module.exports = __webpack_public_path__ + "img/user.a340f715.png";